<form
  (ngSubmit)="handleSubmitClick()"
  [formGroup]="form">
  <div class="flex flex-1 flex-col bg-gray-50 p-6">

    @if (!canBeGroupsEdited()) {
      <div class="mb-5">
        <app-warning>
          <strong>Tryb ograniczonej edycji.</strong>
          Ze względu na ankiety już udostępnione użytkownikom możliwość ich edycji została ograniczona.
        </app-warning>
      </div>
    }

    <app-form-control label="Czas ważności ankiety w godzinach">
      <p-input-number
        [fluid]="true"
        [formControl]="form.controls.validityHours"
        [min]="1"
        [step]="1"
        [useGrouping]="false"
        inputStyleClass="w-full"
        placeholder="Wprowadź czas ważności ankiety" />
    </app-form-control>

    <app-form-control label="Opis">
      <app-summernote
        [formControl]="form.controls.description"
        [uploadFn]="uploadFn()" />
    </app-form-control>

    <app-form-control label="Grupy zawartości">
      <app-admin-box-sale-groups-control
        [formControl]="form.controls.groups"
        [uploadFn]="uploadFn()"
        [allowChangeGroups]="canBeGroupsEdited()"
        [allowChangeCosmetics]="canBeGroupsEdited()" />
    </app-form-control>

    <div class="mt-auto flex justify-end">
      <p-button
        [disabled]="form.invalid"
        appPrimengButton
        label="Zapisz"
        severity="primary"
        type="submit" />
    </div>
  </div>
</form>
